import { useQuery, UserCreditUsageConnection } from '@lojinha/palantir'
import { useLojinhaContext } from '@lojinha/context'
import { GET_DATA_INDICATIONS } from './queries'

type useIndicationProps = {
  referralCouponCode?: string
  referralCredit?: number
  referralRewardAmount?: number
  referralDiscount?: number
  usageCount?: number
  loading?: boolean
  couponUsages?: UserCreditUsageConnection
}

export const useIndication = (): useIndicationProps => {
  const { isAuthenticated } = useLojinhaContext()

  const { data, loading } = useQuery(GET_DATA_INDICATIONS, {
    skip: !isAuthenticated,
  })

  const {
    referralCouponCode,
    referralCredit,
    referralRewardAmount,
    referralDiscount,
    ownCoupon,
    couponUsages,
  } = data?.viewer?.user ?? ''

  const { usageCount } = ownCoupon ?? 0

  return {
    loading,
    referralCouponCode,
    referralCredit,
    referralRewardAmount,
    referralDiscount,
    usageCount,
    couponUsages,
  }
}
